import { LandingPageView } from "@tlc/ls2pac/app/views/LandingPageView";
import * as React from "react";
import { SearchBar } from "../SearchBar";
import { useLocationConfiguration } from "../LocationConfiguration";
import { useSyndeticsConfig } from "../SyndeticsConfig";
import SearchBarContainer from "../SearchBarContainer";
import { useNavigate } from "react-router-dom";
import { useSearchSubmit } from "./search/useSearchSubmit";

export const HomePage: React.FC = function () {
  const { locationConfiguration } = useLocationConfiguration();
  const { syndeticsConfig } = useSyndeticsConfig();
  const navigate = useNavigate();
  const searchSubmit = useSearchSubmit();

  React.useEffect(() => {
    const view = new LandingPageView("homePageContainer");
    view.show();

    return () => {
      view?.cleanup();
    };
  }, []);

  return (
    <>
      <SearchBarContainer>
        <SearchBar
          autoFocus={true}
          sx={{ m: "0 auto" }}
          limitToKids={false}
          voiceSearchEnabled={
            locationConfiguration?.pacSettings?.displaySettings?.voiceInterface
          }
          onClickSearch={searchSubmit}
          onClickTitle={(resource) => {
            navigate(`/resource/${resource.id}`);
          }}
          syndeticsClientCode={syndeticsConfig?.clientCode}
          branchFilters={locationConfiguration?.filterBranches}
        ></SearchBar>
      </SearchBarContainer>
      <div id="homePageContainer"></div>
    </>
  );
};
